import(/* webpackMode: "eager", webpackExports: ["AuthView"] */ "/vercel/path0/node_modules/@daveyplate/better-auth-ui/dist/index.js");
